import { Text } from '@chakra-ui/react';

export const DeactivatedMessage: React.FC = () => {
  return <Text>This event has been deactivated</Text>;
};
